import { motion } from 'framer-motion';
import type { Easing } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const ease: Easing = 'easeOut';

const reveal = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: '-40px' },
  transition: { duration: 0.5, ease },
};

const StudioSection = () => {
  const { t } = useTranslation();

  return (
    <section id="studio" className="section-padding bg-background">
      <div className="max-w-[720px] mx-auto">
        <motion.h2
          {...reveal}
          className="text-display text-section text-foreground italic mb-12 md:mb-16 text-center md:text-left"
        >
          {t('brooklyn.studio.title')}
        </motion.h2>

        <div className="space-y-8 md:space-y-10">
          <motion.p {...reveal} className="text-body-fluid text-muted-foreground leading-relaxed-body text-center md:text-left">
            {t('brooklyn.studio.p1')}
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ duration: 0.5, ease, delay: 0.08 }}
            className="text-body-fluid text-muted-foreground leading-relaxed-body text-center md:text-left"
          >
            {t('brooklyn.studio.p2')}
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ duration: 0.5, ease, delay: 0.16 }}
            className="text-body-fluid text-muted-foreground leading-relaxed-body text-center md:text-left"
          >
            {t('brooklyn.studio.p3')}
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ duration: 0.5, ease, delay: 0.24 }}
            className="text-body-fluid font-display text-lg md:text-xl text-foreground/80 italic text-center md:text-left"
          >
            {t('brooklyn.studio.p4')}
          </motion.p>
        </div>
      </div>
    </section>
  );
};

export default StudioSection;
